module.exports = __webpack_public_path__ + "img/onp_1.93fdba59.gif";